import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';


@Component({
  selector: 'app-maincontractus',
  templateUrl: './maincontractus.component.html',
  styleUrls: ['./maincontractus.component.css']
})
export class MaincontractusComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
      $(document).ready(() => {
        $.getScript('../assets/js/leaflet-hireo.js')
        $.getScript('../assets/js/leaflet-markercluster.min.js')
        $.getScript('../assets/js/leaflet-gesture-handling.min.js')
        $.getScript('../assets/js/scripts/contractUs.js')
      })
  }
}
